import type { MenuItem } from 'primevue/menuitem'
import { useLocalStorage } from '@vueuse/core'

const layoutConfig = useLocalStorage<{
  preset: LayoutPreset
  primary: LayoutPrimary | 'sos'
  paletteVersion?: number
  surface?: LayoutSurface
  menuMode: LayoutMenuMode
}>('layoutConfig', {
  preset: 'Aura',
  primary: 'blue',
  paletteVersion: 2,
  surface: undefined,
  menuMode: 'static',
})

// Upgrade the old defaults once. Colors selected in the picker afterwards persist.
if (import.meta.client && !layoutConfig.value.paletteVersion) {
  const old = layoutConfig.value
  layoutConfig.value = {
    ...old,
    primary:
      old.primary === 'sos' || old.primary === 'emerald' ? 'blue' : old.primary,
    paletteVersion: 2,
  }
}

const layoutState = useLocalStorage<{
  staticMenuDesktopInactive: boolean
  overlayMenuActive: boolean
  profileSidebarVisible: boolean
  configSidebarVisible: boolean
  staticMenuMobileActive: boolean
  menuHoverActive: boolean
  activeMenuItem?: MenuItem
}>('layoutState', {
  staticMenuDesktopInactive: false,
  overlayMenuActive: false,
  profileSidebarVisible: false,
  configSidebarVisible: false,
  staticMenuMobileActive: false,
  menuHoverActive: false,
  activeMenuItem: undefined,
})

export function useTemplateLayout() {
  const setActiveMenuItem = (item: MenuItem) => {
    layoutState.value.activeMenuItem = item.value || item
  }

  const toggleMenu = () => {
    if (layoutConfig.value.menuMode === 'overlay') {
      layoutState.value.overlayMenuActive = !layoutState.value.overlayMenuActive
    }

    if (window.innerWidth > 991) {
      layoutState.value.staticMenuDesktopInactive =
        !layoutState.value.staticMenuDesktopInactive
    } else {
      layoutState.value.staticMenuMobileActive =
        !layoutState.value.staticMenuMobileActive
    }
  }

  return {
    layoutConfig,
    layoutState,
    toggleMenu,
    setActiveMenuItem,
  }
}
